import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Every axios call across the app uses a relative path (e.g.
// '/api/convert/merge'), not a full URL — so in production those requests
// would otherwise go to whatever domain the frontend itself is served from,
// not the actual backend. Setting the base URL once, here, makes every one
// of those existing calls resolve correctly without touching each call
// site. REACT_APP_API_URL is empty in dev (.env.development) so local
// requests stay relative and go through CRA's proxy to localhost:5000; in
// production (.env.production) it points at the real backend host.
axios.defaults.baseURL = process.env.REACT_APP_API_URL || '';

// react-snap prerenders each route to real static HTML at build time so
// crawlers get actual content without running JS. When a visitor's browser
// loads that HTML, React needs to *hydrate* it (reuse the existing DOM)
// rather than createRoot()'s plain render, which would wipe out the
// prerendered markup and redraw from scratch — visible as a content flash.
// `npm start` never has prerendered content, so it still falls back to a
// normal render.
const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

// Registers the PWA service worker (production builds only) so mobile/
// desktop browsers offer the "install app" / "add to home screen" prompt.
serviceWorkerRegistration.register();
